import React, {Component} from 'react';
import {TextareaItem,Toast} from 'antd-mobile';
import {changeOrderInfo,getChangeOrderPrice,changeOrder} from "../../../service/shiftService";
import {connect} from "react-redux";
import "./style.less";
import { throws } from 'assert';
const yixuan = require('../../../common/image/yixuan.png');
const kexuan = require('../../../common/image/kexuan.png');
const xuanzhong = require('../../../common/image/xuanzhong.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class OrderChange extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            priceTotal:0,
            seatSelIndex:'',
            seatData: [],
            currentSeat:false,
            startCity:'',
            endCity:'',
            carNum:'',
            pickUpTime:'',
            startTime:'',
            endTime:'',
            lineId:'',
            charge:0,
            differencePrice:0,
            seatId:'',
            originalPrice:0,
            seatPrice:'',
            pickUpPrice:0,
            deliveryPrice:0,
            seatNum:'',
        };
    }

    componentDidMount() {
        this.changeShiftList();
    }
    //确认改签，跳转支付页面
    reserveModal(){
        const props = this.props.history.location.state
        let params = {
            "token": this.props.userInfo.token,
            "data": {
                "id":props.orderId,//原订单Id
                "startPosition":props.startPosition,
                "endPosition":props.endPosition,
                "startStationId": props.startStationId,
                "endStationId": props.endStationId,
                "lineId": this.state.lineId,
                "shiftId": props.shiftId,
                "startAddress": props.startAddress,
                "endAddress": props.endAddress,
                "startCity":this.state.startCity,
                "endCity": this.state.endCity,
                "seatId": this.state.seatId,
                "seatPrice": this.state.seatPrice,
                "pickUpPrice": this.state.pickUpPrice,
                "deliveryPrice": this.state.deliveryPrice,
                "charge": props.type === "special" ? 0 : this.state.charge,
                "differencePrice": props.type === "special" ? 0 : this.state.differencePrice,
                "endorseSource":props.type === "special" ? 11 : 10//特殊改签传11
            }
          }
          console.log(params)
        //   return
          Toast.loading("正在加载",0);
          changeOrder(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.hide();
                    //跳转支付页面
                    // this.props.history.push(`/shiftDetails/${props.classId}`)
                    props.type === "special" ?  Toast.info('特殊改签成功',2,this.props.history.push('/home')) :
                    this.props.history.push('/payDetail',{
                        orderNum:res.data.data,
                        seatNum:this.state.seatNum,
                        totalPrice:(this.state.differencePrice + this.state.charge).toFixed(2),
                        type:1,//0是正常支付，1是改签，2是发票
                    })//把订单号,出行位置号，总价传到支付页面
                   
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {

                    this.setState({ changeShiftData:[]})
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
              console.log(error);
          });
    }

    //获取改签行程详情
    changeShiftList = () => {
        const props = this.props.history.location.state
        let params = {
            "token": this.props.userInfo.token,
            "data": {
                "id":props.shiftId,
                "startPosition":props.startPosition,
                "endPosition":props.endPosition,
                "startStationId": props.startStationId,
                "endStationId": props.endStationId
            }
          }
          console.log(params)
          Toast.loading("正在加载",0);
          changeOrderInfo(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    let data = res.data.data
                    data.seatList.map((r)=>{
                        r.flag = false;
                    })
                    Toast.hide();
                    this.setState({
                        startCity:data.startCity,
                        endCity:data.endCity,
                        carNum:data.carNum,
                        pickUpTime:data.pickUpTime,
                        date:data.date,
                        weekend:data.weekend,
                        startTime:data.startTime,
                        endTime:data.endTime,
                        seatData:data.seatList,
                        lineId:data.lineId,
                       
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {

                    this.setState({ changeShiftData:[]})
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
              console.log(error);
          });
    };
    //计算价格明细
    // changeShiftList = () => {
       
    // }
    //选出行位置/更换
    selSeat(i,r,j) {
        this.setState({
            seatId: r.id,
            seatPrice:r.seatPrice,
            pickUpPrice:r.pickUpPrice,
            deliveryPrice:r.deliveryPrice,
            seatNum:r.seatNum
        })
        if(r.status == 1){
            r.flag = true
        }
        this.state.seatData.map((res,index)=>{
            if(index !== i){
                res.flag = false;
            }
        });
        if(j === "special"){
            return
        }else{
            const props = this.props.history.location.state
            if(r.status == 1){
                let params = {
                    "token": this.props.userInfo.token,
                    "data":{
                        "shiftId": props.shiftId,
                        "seatId": r.id,
                        "id":props.orderId,//订单id
                        "startPosition":props.startPosition,
                        "endPosition":props.endPosition,
                        "startStationId": props.startStationId,
                        "endStationId": props.endStationId
                    }
                }
                    console.log(params)
                    Toast.loading("正在加载",0);
                    getChangeOrderPrice(params)
                        .then((res) => {
                            console.log(res)
                            if (res.data.code === '0000') {
                            let data = res.data.data
                                Toast.hide();
                                this.setState({
                                    originalPrice:data.originalPrice,
                                    charge:data.charge,
                                    differencePrice:data.differencePrice,
                                    priceTotal:data.charge + data.differencePrice
                                })
                            }
                            else if (res.data.code === '1401') {
                                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                            }
                            else {
            
                                this.setState({ changeShiftData:[]})
                                Toast.info(res.data.msg);
                            }
                        }).catch(function (error) {
                        console.log(error);
                    });
            }
        }
       
    }


    render(){
        const props = this.props.history.location.state
        return(
            <div className="orderChange">
                <div className="goBack">
                    <i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />
                    <span>改签</span>
                </div>

                <div className="warpBox">
                    <div className="content">
                        <div className="topBar">
                            <div className="cityContent">
                                <span className="start">{this.state.startCity}</span>
                                <div><span>—</span><div className="carNum">{this.state.carNum}</div><span>—</span></div>
                                <span className="end">{this.state.endCity}</span>
                            </div>
                            <div className="time">
                                <span className="">{this.state.startTime}</span>
                                <span className="">{this.state.endTime}</span>
                            </div>
                            <p>{this.state.date} {this.state.weekend} {this.state.pickUpTime}开始接人</p>
                        </div>

                        <div className="selSeat">
                            <div className="seatTop">
                                <span className="title">预定出行位置</span>
                                <div className="bottom">
                                    <div className="kexuan"><img src={kexuan} />可选</div>
                                    <div className="xuanzhong"><img src={xuanzhong} />选中</div>
                                    <div><img src={yixuan} />被选</div>
                                </div>
                            </div>
                            <div className="seatBottom">
                                <div className="title">
                                    <div>前排</div>
                                    <div className='middle'>中排</div>
                                    <div>后排</div>
                                </div>
                                <div className="seatsBox">

                                    <div className="selected">
                                        <img src={yixuan} />
                                        <span>司机</span>
                                    </div>
                                    {
                                        this.state.seatData.map((res, i) => {
                                            return(
                                                <div
                                                    key={i}
                                                    className={res.status == 1  ? ( res.flag === false ?  '' :'sel') :'selected' }
                                                    // className={(res.isCheck === 1 || res.isLock === 1) ? 'selected' : res.isCheck === 0 && res.flag === false ? '' :  'sel'}
                                                    style={i > this.state.seatData.length - 4 ? {width: '31.33%'} : {}}
                                                    onClick={() => this.selSeat ? this.selSeat(i,res,props.type) : null}
                                                >
                                                    {res.status == 1 ?  (res.flag === false ?  <img src={kexuan} /> :<img src={xuanzhong} />):<img src={yixuan} /> }
                                                    {/*(res.isCheck === 1 || res.isLock === 1) ? <img src={yixuan} /> : res.isCheck === 0  && res.flag === false ? <img src={kexuan} /> :  <img src={xuanzhong} />}
                                                    {/*{this.seatJudge(res)}*/}
                                                    <span>{res.seatPrice}</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                        </div>
                            {
                                props.type === "special" ? null : 
                                <div className="picDetails">
                                    <div className="tit">价格明细</div>
                                    <div className="oldOrder">
                                        <span className="tit">原订单:</span>
                                        {this.state.originalPrice ? <span>￥{this.state.originalPrice}</span> :  null} 
                                    </div>
                                    <div className="oldOrder">
                                        <span className="tit">手续费:</span>
                                        {this.state.charge ? <span>￥{this.state.charge}</span>: null } 
                                    </div>
                                    <div className="oldOrder">
                                        <span className="tit">差价:</span>
                                        {this.state.differencePrice ? <span>￥{this.state.differencePrice}</span>: null }
                                    </div>
                                </div>
                            }
                            {
                                props.type === "special" ?  
                                <div className="picDetails">
                                    <div className="tit">特殊改签价格明细</div>
                                    <div className="oldOrder">
                                        <span className="tit">原订单:</span>
                                        {props.totalPrice}
                                    </div>
                                    <div className="oldOrder">
                                        <span className="tit">手续费:</span>
                                        <span>0</span>
                                    </div>
                                    <div className="oldOrder">
                                        <span className="tit">差价:</span>
                                        <span>0</span>
                                    </div>
                                </div> : null
                            }

                    {/*  <div className="explain">
                            <div className="tit">价格明细</div>
                            <TextareaItem
                                placeholder="输入内容"
                                rows={3}
                            />
                        </div>
                        <div className="text">
                            <p>如果手续费发生变更，请填写特殊情况说明</p>
                            <p>手续费发生变更后进入审核环节，如情况不属实则取消变更</p>
                        </div>
                    */}
                    {
                        props.type === "special" ? 
                            <div className="special">
                                <div>关于特殊改签</div>
                                <div>1.特殊改签之前，请先确保与乘客协商一致；</div>
                                <div>2.特殊改签不需要支付手续费和差价。</div>
                            </div> 
                        : null
                    }
                    </div>
                </div>

                <div className="footer">
                    <div className="payTotal">合计：
                       {props.type === 'special'? <span>0</span>: <span>￥{this.state.priceTotal.toFixed(2)}</span> } 
                    </div>
                    <button className="go" onClick={() => this.reserveModal()}>确认改签</button>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/OrderChange/index.js